module.exports = __webpack_public_path__ + "static/01-3e0b3de533fd2040f061b2702638699c.jpg";